import React from 'react';
import { Link } from 'react-router-dom';

const BlogNotFound: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: '#050505' }}>
    <div className="text-center px-6 py-24">
      <p className="text-5xl font-bold mb-4" style={{ color: '#14B8A6' }}>404</p>
      <h1 className="text-2xl font-semibold text-white mb-4">Post not found</h1>
      <p className="text-gray-400 mb-8 max-w-md mx-auto">
        This article may have been moved or deleted. Browse our latest insights below.
      </p>
      <Link
        to="/insights"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200"
        style={{ background: '#14B8A6' }}
      >
        Browse all articles
      </Link>
    </div>
  </div>
);

export default BlogNotFound;
